import GroupSitesMenu from './group-sites-menu'
import MobileMenu from './mobile-menu'
import NavigationMenus from './navigation-menus'

document.addEventListener('DOMContentLoaded', () => {
  window.themeNavMenus = new NavigationMenus()
  window.themeGroupSitesMenu = new GroupSitesMenu()
  window.themeMobileMenu = new MobileMenu()
})